import axios from 'axios'

export default {
    namespaced: true,

    state: {
        authenticated: false,
        user: {student_id: null, student_name: null},
        userRecord: null,
        studentRecord: null,
        overlay: false,
        dialog: false,
        loginErrors: '',       
        newPassword: '',
        displayPasswordChanged: false,
        validStudentID: false,
        userInitials: '',
        schoolName: process.env.VUE_APP_THEME_SCHOOL, 
    },

    getters: {
        getAuthenticated (state) {
            return state.authenticated
        },

        getUser (state) {
            return state.user
        },

        getUserId (state) {
            return state.user.student_id
        },

        getUserRecord(state){
            return state.userRecord
        },

        getOverlay(state){
            return state.overlay
        },

        getStudentRecord(state){
            return state.studentRecord
        },

        getDialog(state){
            return state.dialog
        },

        getLoginErrors(state){
            return state.loginErrors
        },       

        getNewPassword(state){
            return state.newPassword
        },

        getDisplayPasswordChanged(state){
            return state.displayPasswordChanged
        },

        getStudentIDValidation(state){
            return state.validStudentID
        },

        getUserInitials(state){
            return state.userInitials
        },

        getSchoolName (state) {
            return state.schoolName
        }
    },

    mutations: {
        setAuthenticated (state, value) {
            state.authenticated = value
        },

        setUser (state, value) {
            state.user = value
        },

        setUserId (state, value){
            state.user.student_id = value;
        },

        setUserRecord (state, value){
            state.userRecord = value
        },

        setOverlay (state, value){
            state.overlay = value
        },

        setStudentRecord(state, value){
            state.studentRecord = value
        },

        setDialog(state, value){
            state.dialog = value
        },

        setLoginErrors(state, value){
            state.loginErrors = value
        },        

        setNewPassword(state, value){
            state.newPassword = value
        },

        setDisplayPasswordChanged(state, value){
            state.displayPasswordChanged = value
        },

        setStudentIDValidation(state, value){
            state.validStudentID = value
        },

        setUserInitials(state, value){
            state.userInitials = value
        }
    },

    actions: {
        async signIn ({ commit, dispatch }, credentials){ 
            let response = null;           
            commit('setOverlay', true);
                       
            try{
                await axios.get('/sanctum/csrf-cookie')
                console.log("authenticating login credentials");
                response = await axios.post('/api/login-student', credentials);
                //console.log(response);
                console.log('authenticated');
                commit('setUser', credentials);
                commit('setStudentRecord', response.data);
                dispatch('student');                
                commit('setAuthenticated', true);
                //console.log(getters.getAuthenticated);                
            } catch(error){
                console.log(error.response);
                console.log(error.response);                        
                commit('setLoginErrors', error.response.data.message);
                commit('setAuthenticated', false);
                commit('setOverlay', false); 
            }

        },

        student({ getters, commit }){                  
            commit('setUserInitials', getters.getStudentRecord.first_name[0] + getters.getStudentRecord.last_name[0]);
            commit('setUserRecord', {name: getters.getStudentRecord.first_name + ' ' + getters.getStudentRecord.last_name});                  
        },

        async user({ getters, commit }){
            console.log("getting user information...");
            let url = '/api/user/' + getters.getUserId;           
            await axios.get(url)
                .then(response => {
                    console.log(response.status);
                    if(response.data.length != 0){
                        commit('setStudentIDValidation', true)
                        commit('setLoginErrors', '');
                        commit('setUserRecord', response.data[0]);                        
                    }
                    else{
                        commit('setLoginErrors', 'Student ID not found');
                        commit('setStudentIDValidation', false)
                        commit('setAuthenticated', false);
                        commit('setOverlay', false);                      
                    }                  
                })
        },        

        async signOut({commit}){                       
            await axios.post('/logout')
                    .then(response => {
                        console.log(response);
                    })
            return commit('setAuthenticated', false); 
        },

       checkSession({dispatch}){           
           console.log(`Cookie Set: ${dispatch('cookieSet', 'ans_api_session')}`);
       },

       async getStudents(){
           try{
                return await axios.get('/api/students')
           }
           catch (error) {
                console.log(error);
           }
           
       },       

       cookieSet(cookieName){
           let name = cookieName + "=";
           let decodedCookie = decodeURIComponent(document.cookie);
           let cookies = decodedCookie.split(';');
           for(var i = 0; i < cookies.length; i++){
               var c = cookies[i];
               while(c.charAt(0) == ' '){
                   c = c.substring(1);
               }
               if(c.indexOf(name) == 0){
                    return true;
               }
           }
           return false;
       }
    }
}